import {Component} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle,} from '@angular/material/dialog';
import {Interval} from '@app/landing/upgrade/upgrade.component';

export class UpgradeData {
    seats: number;
    interval: Interval;
    promo: string;
}

@Component({
    selector: 'frog-upgrade-dialog',
    templateUrl: './upgrade-dialog.component.html',
    styleUrls: ['./upgrade-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class UpgradeDialogComponent {
    constructor() {}
}
